// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_auto_creation_rule_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { WorkflowAutoCreationDayFilter, WorkflowAutoCreationLeadUnit, WorkflowAutoCreationRule } from "./workflow_auto_creation_rule_model_pb";
import { file_bffuser_v1_workflow_auto_creation_rule_model } from "./workflow_auto_creation_rule_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { TimeOfDay } from "../../google/type/timeofday_pb";
import { file_google_type_timeofday } from "../../google/type/timeofday_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_auto_creation_rule_service.proto.
 */
export const file_bffuser_v1_workflow_auto_creation_rule_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_workflow_auto_creation_rule_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_timeofday]);

/**
 * @generated from message bffuser.v1.ListWorkflowAutoCreationRulesRequest
 */
export type ListWorkflowAutoCreationRulesRequest = Message<"bffuser.v1.ListWorkflowAutoCreationRulesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListWorkflowAutoCreationRulesRequest.
 * Use `create(ListWorkflowAutoCreationRulesRequestSchema)` to create a new message.
 */
export const ListWorkflowAutoCreationRulesRequestSchema: GenMessage<ListWorkflowAutoCreationRulesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 0);

/**
 * @generated from message bffuser.v1.ListWorkflowAutoCreationRulesResponse
 */
export type ListWorkflowAutoCreationRulesResponse = Message<"bffuser.v1.ListWorkflowAutoCreationRulesResponse"> & {
  /**
   * Empty when feature_enabled is false.
   *
   * @generated from field: repeated bffuser.v1.WorkflowAutoCreationRule rules = 1;
   */
  rules: WorkflowAutoCreationRule[];

  /**
   * Evaluated value of the workflow-auto-creation-rule feature flag (false
   * on evaluation failure).
   *
   * @generated from field: bool feature_enabled = 2;
   */
  featureEnabled: boolean;
};

/**
 * Describes the message bffuser.v1.ListWorkflowAutoCreationRulesResponse.
 * Use `create(ListWorkflowAutoCreationRulesResponseSchema)` to create a new message.
 */
export const ListWorkflowAutoCreationRulesResponseSchema: GenMessage<ListWorkflowAutoCreationRulesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 1);

/**
 * WorkflowAutoCreationScheduleTriggerInput is the 定期 payload of a write
 * request.
 *
 * @generated from message bffuser.v1.WorkflowAutoCreationScheduleTriggerInput
 */
export type WorkflowAutoCreationScheduleTriggerInput = Message<"bffuser.v1.WorkflowAutoCreationScheduleTriggerInput"> & {
  /**
   * @generated from field: int32 lead_value = 1;
   */
  leadValue: number;

  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationLeadUnit lead_unit = 2;
   */
  leadUnit: WorkflowAutoCreationLeadUnit;

  /**
   * @generated from field: google.type.TimeOfDay fire_time = 3;
   */
  fireTime?: TimeOfDay;

  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationDayFilter day_filter = 4;
   */
  dayFilter: WorkflowAutoCreationDayFilter;
};

/**
 * Describes the message bffuser.v1.WorkflowAutoCreationScheduleTriggerInput.
 * Use `create(WorkflowAutoCreationScheduleTriggerInputSchema)` to create a new message.
 */
export const WorkflowAutoCreationScheduleTriggerInputSchema: GenMessage<WorkflowAutoCreationScheduleTriggerInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 2);

/**
 * @generated from message bffuser.v1.CreateWorkflowAutoCreationRulesRequest
 */
export type CreateWorkflowAutoCreationRulesRequest = Message<"bffuser.v1.CreateWorkflowAutoCreationRulesRequest"> & {
  /**
   * @generated from field: string workflow_template_id = 2;
   */
  workflowTemplateId: string;

  /**
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 3;
   */
  areaCodes: AreaCode[];

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * @generated from oneof bffuser.v1.CreateWorkflowAutoCreationRulesRequest.trigger
   */
  trigger: {
    /**
     * @generated from field: bffuser.v1.WorkflowAutoCreationScheduleTriggerInput schedule = 10;
     */
    value: WorkflowAutoCreationScheduleTriggerInput;
    case: "schedule";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.CreateWorkflowAutoCreationRulesRequest.
 * Use `create(CreateWorkflowAutoCreationRulesRequestSchema)` to create a new message.
 */
export const CreateWorkflowAutoCreationRulesRequestSchema: GenMessage<CreateWorkflowAutoCreationRulesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 3);

/**
 * @generated from message bffuser.v1.CreateWorkflowAutoCreationRulesResponse
 */
export type CreateWorkflowAutoCreationRulesResponse = Message<"bffuser.v1.CreateWorkflowAutoCreationRulesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.WorkflowAutoCreationRule rules = 1;
   */
  rules: WorkflowAutoCreationRule[];

  /**
   * Requested areas that were not created because a scheduled rule for the
   * same template already exists.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode skipped_area_codes = 2;
   */
  skippedAreaCodes: AreaCode[];
};

/**
 * Describes the message bffuser.v1.CreateWorkflowAutoCreationRulesResponse.
 * Use `create(CreateWorkflowAutoCreationRulesResponseSchema)` to create a new message.
 */
export const CreateWorkflowAutoCreationRulesResponseSchema: GenMessage<CreateWorkflowAutoCreationRulesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 4);

/**
 * @generated from message bffuser.v1.UpdateWorkflowAutoCreationRuleRequest
 */
export type UpdateWorkflowAutoCreationRuleRequest = Message<"bffuser.v1.UpdateWorkflowAutoCreationRuleRequest"> & {
  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string workflow_template_id = 3;
   */
  workflowTemplateId: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;

  /**
   * @generated from oneof bffuser.v1.UpdateWorkflowAutoCreationRuleRequest.trigger
   */
  trigger: {
    /**
     * @generated from field: bffuser.v1.WorkflowAutoCreationScheduleTriggerInput schedule = 10;
     */
    value: WorkflowAutoCreationScheduleTriggerInput;
    case: "schedule";
  } | { case: undefined; value?: undefined };

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the rule.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 20;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowAutoCreationRuleRequest.
 * Use `create(UpdateWorkflowAutoCreationRuleRequestSchema)` to create a new message.
 */
export const UpdateWorkflowAutoCreationRuleRequestSchema: GenMessage<UpdateWorkflowAutoCreationRuleRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 5);

/**
 * @generated from message bffuser.v1.UpdateWorkflowAutoCreationRuleResponse
 */
export type UpdateWorkflowAutoCreationRuleResponse = Message<"bffuser.v1.UpdateWorkflowAutoCreationRuleResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationRule rule = 1;
   */
  rule?: WorkflowAutoCreationRule;
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowAutoCreationRuleResponse.
 * Use `create(UpdateWorkflowAutoCreationRuleResponseSchema)` to create a new message.
 */
export const UpdateWorkflowAutoCreationRuleResponseSchema: GenMessage<UpdateWorkflowAutoCreationRuleResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 6);

/**
 * @generated from message bffuser.v1.DeleteWorkflowAutoCreationRuleRequest
 */
export type DeleteWorkflowAutoCreationRuleRequest = Message<"bffuser.v1.DeleteWorkflowAutoCreationRuleRequest"> & {
  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the rule.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteWorkflowAutoCreationRuleRequest.
 * Use `create(DeleteWorkflowAutoCreationRuleRequestSchema)` to create a new message.
 */
export const DeleteWorkflowAutoCreationRuleRequestSchema: GenMessage<DeleteWorkflowAutoCreationRuleRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 7);

/**
 * DeleteWorkflowAutoCreationRuleResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteWorkflowAutoCreationRuleResponse
 */
export type DeleteWorkflowAutoCreationRuleResponse = Message<"bffuser.v1.DeleteWorkflowAutoCreationRuleResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteWorkflowAutoCreationRuleResponse.
 * Use `create(DeleteWorkflowAutoCreationRuleResponseSchema)` to create a new message.
 */
export const DeleteWorkflowAutoCreationRuleResponseSchema: GenMessage<DeleteWorkflowAutoCreationRuleResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 8);

/**
 * WorkflowAutoCreationRuleService manages 自動起票ルール (spec
 * docs/specs/workflow/workflow-templates.md §4) for the admin template page.
 * organization_id and the acting member are resolved by the BFF handler from
 * eauth.
 * The service is released by the global workflow-auto-creation-rule feature
 * flag: while it is off, List returns feature_enabled=false with no rules
 * and every write returns FAILED_PRECONDITION.
 *
 * @generated from service bffuser.v1.WorkflowAutoCreationRuleService
 */
export const WorkflowAutoCreationRuleService: GenService<{
  /**
   * ListWorkflowAutoCreationRules returns the active rules of the
   * organization, ordered by created_at then id. Rules whose template is
   * deleted or cannot be resolved are not returned.
   *
   * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.ListWorkflowAutoCreationRules
   */
  listWorkflowAutoCreationRules: {
    methodKind: "unary";
    input: typeof ListWorkflowAutoCreationRulesRequestSchema;
    output: typeof ListWorkflowAutoCreationRulesResponseSchema;
  },
  /**
   * CreateWorkflowAutoCreationRules creates one rule per requested area,
   * skipping areas that already have a scheduled rule for the same template.
   * Returns ALREADY_EXISTS when every requested area is skipped, and
   * FAILED_PRECONDITION when the template does not exist in the organization
   * or cannot have a scheduled rule.
   *
   * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.CreateWorkflowAutoCreationRules
   */
  createWorkflowAutoCreationRules: {
    methodKind: "unary";
    input: typeof CreateWorkflowAutoCreationRulesRequestSchema;
    output: typeof CreateWorkflowAutoCreationRulesResponseSchema;
  },
  /**
   * UpdateWorkflowAutoCreationRule replaces a rule. When the template or the
   * area changes, the rule is recreated under a new id (the old rule is
   * logically deleted) and the response carries the new id. Returns
   * ALREADY_EXISTS on a template × area clash, FAILED_PRECONDITION for an
   * ineligible template, NOT_FOUND for a missing rule and ABORTED when
   * expected_updated_at does not match.
   *
   * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.UpdateWorkflowAutoCreationRule
   */
  updateWorkflowAutoCreationRule: {
    methodKind: "unary";
    input: typeof UpdateWorkflowAutoCreationRuleRequestSchema;
    output: typeof UpdateWorkflowAutoCreationRuleResponseSchema;
  },
  /**
   * DeleteWorkflowAutoCreationRule logically deletes a rule. Returns NOT_FOUND
   * for a missing rule and ABORTED when expected_updated_at does not match.
   *
   * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.DeleteWorkflowAutoCreationRule
   */
  deleteWorkflowAutoCreationRule: {
    methodKind: "unary";
    input: typeof DeleteWorkflowAutoCreationRuleRequestSchema;
    output: typeof DeleteWorkflowAutoCreationRuleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_workflow_auto_creation_rule_service, 0);

